import type { CarSpecs, EcosystemVehicle } from '~/types';
import { useCustomLocaleMapping, type LocaleType } from '~/composables';

export function useVehicleDetails () {
  const { t, locale } = useI18n({
    messages: {
      es: {
        vehicle_info: 'Información del vehículo',
      },
      en: {
        vehicle_info: 'Vehicle information',
      },
      pt: {
        vehicle_info: 'Informações do veículo',
      },
    },
  });

  const route = useRoute();
  const carSpecs = ref<CarSpecs>({
    id: route.params?.slug as string,
    model: '',
    version: '',
    make: '',
    ecoLabel: null,
    meta: {
      isLead: true,
    },
    perks: [],
    colors: [],
    price: '',
    prices: [],
    stations: [],
    description: '',
    imageSrc: '',
    features: [],
    policies: [],
    kmPrices: [],
  });

  function setCarSpecsModel (carDetails: EcosystemVehicle, cb: () => void) {
    const { t: carT, findAndReplace } = useCustomLocaleMapping(locale.value as LocaleType);
    carSpecs.value.id = carDetails.id;
    carSpecs.value.prices = carDetails.prices;
    carSpecs.value.model = carDetails.make + ' ' + carDetails.model;
    carSpecs.value.version = carDetails.version;
    carSpecs.value.make = carDetails.make;
    carSpecs.value.ecoLabel = carDetails.eco_label;
    carSpecs.value.imageSrc = carDetails.image_src;
    carSpecs.value.description = carDetails.description;
    carSpecs.value.colors = carDetails.colors;
    carSpecs.value.stations = carDetails.stations;
    carSpecs.value.policies = carDetails.policies;
    carSpecs.value.kmPrices = carDetails.km_prices;

    const carFeaturesFromDetails = [
      `${carDetails.seats || 5} ${carT('seat', carDetails.seats)}`,
      carT(carDetails.transmission),
      findAndReplace(carDetails.engine),
      carT(carDetails.vehicle_size as string),
      findAndReplace(carDetails.vehicle_type as string),
      carT(carDetails.traction_type as string),
    ].filter(Boolean);
    carSpecs.value.perks = carFeaturesFromDetails as string[];

    const defaultColor = carDetails.colors.at(0);
    carSpecs.value.color = defaultColor;

    const vehicleInfo = carDetails.vehicle_info;
    carSpecs.value.features.push({
      id: 1,
      title: t('vehicle_info'),
      body: vehicleInfo.map(item => (`- ${item}`)).join('\n'),
    });

    cb();
  }

  return {
    carSpecs,
    setCarSpecsModel,
  };
}
